"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskListSummaryBanner = void 0;
const react_1 = __importDefault(require("react"));
const Card_1 = require("@amzn/atoz-web/Card");
const Text_1 = require("@amzn/atoz-web/Text");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const Theme_1 = require("@amzn/atoz-web/Theme");
const consts_1 = require("../../consts");
const useTaskListSummaryBanner_1 = require("./hooks/useTaskListSummaryBanner");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
const BIAnalytics_1 = require("../../utils/BIAnalytics/BIAnalytics");
const TaskListSummaryBanner = ({ isTaskListForWebEnabled = false, requireAttentionItemsCount }) => {
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { bannerText, bannerIconAltText, bannerLinkText } = (0, useTaskListSummaryBanner_1.useTaskListSummaryBanner)({
        requireAttentionItemsCount
    });
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.TASK_LIST_LINK_IN_TIMECARD.COUNT
        },
        isComponentLoaded: true
    });
    const onLinkClick = () => {
        var _a;
        logger_1.logger.emitCountMetric({
            metricName: logger_1.METRICS.TASK_LIST_LINK_IN_TIMECARD_CLICKED.COUNT,
            dimensions
        });
        (_a = BIAnalytics_1.BIAnalytics.visitTaskListFromTimecard) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
    };
    return (isTaskListForWebEnabled && (react_1.default.createElement(StyledCard, { dataTestId: "TaskListSummaryBanner" },
        react_1.default.createElement(MessageBanner_1.MessageBanner, { iconAltText: bannerIconAltText, type: !!requireAttentionItemsCount
                ? MessageBanner_1.MessageBannerType.Error
                : MessageBanner_1.MessageBannerType.Informational },
            react_1.default.createElement(Text_1.Text, null, bannerText),
            react_1.default.createElement(MessageBanner_1.MessageBannerLink, { dataTestId: "TaskListLink", href: consts_1.ATOZ_FEATURE_PATH.TASK_LIST, "aria-label": bannerLinkText, onClick: onLinkClick }, bannerLinkText)))));
};
exports.TaskListSummaryBanner = TaskListSummaryBanner;
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
   border: none;
   display: flex;
   &>div {
    flex: 1;
   }
`);
